import { useEffect, useState } from "react";

let deferred = null;
const listeners = new Set();

const emit = () => listeners.forEach((fn) => fn(!!deferred));

if (typeof window !== "undefined") {
  window.addEventListener("beforeinstallprompt", (e) => {
    e.preventDefault();
    deferred = e;
    emit();
  });
  window.addEventListener("appinstalled", () => {
    deferred = null;
    emit();
  });
}

export const isStandalone = () =>
  typeof window !== "undefined"
  && (window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true);

export const isIOS = () =>
  typeof navigator !== "undefined" && /iphone|ipad|ipod/i.test(navigator.userAgent);

/** Tracks whether the browser can install this app, and triggers the prompt. */
export const useInstallPrompt = () => {
  const [canInstall, setCanInstall] = useState(!!deferred);

  useEffect(() => {
    listeners.add(setCanInstall);
    return () => listeners.delete(setCanInstall);
  }, []);

  const install = async () => {
    if (!deferred) return "unavailable";
    const evt = deferred;
    deferred = null;
    emit();
    evt.prompt();
    const { outcome } = await evt.userChoice;
    return outcome;
  };

  return { canInstall, install, installed: isStandalone(), ios: isIOS() };
};

export const registerServiceWorker = () => {
  if (typeof window === "undefined" || !("serviceWorker" in navigator)) return;
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {});
  });
};
